<template>
  <div class="app-customer-address">
    <slot name="txtBefore"></slot>
    <span>{{ currentCustomer.salutation }} {{ currentCustomer.firstName }} {{ currentCustomer.lastName }}</span>
    <span>{{ currentCustomer.address.street }} {{ currentCustomer.address.houseNumber }}</span>
    <span>{{ currentCustomer.address.zip }} {{ currentCustomer.address.city }}</span>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import slotProxy from '../../../../../../mixins/slotProxy'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'

export default {
  name: 'CustomerAddress',
  mixins: [
    slotProxy()
  ],
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        }
      }
    }
  },
  props: {
    processName: {
      type: String,
      default: ''
    }
  },
  apollo: {
    currentCustomer: function () {
      const processName = this.processName
      return wrapQuery(
        gql`query ${processName} {
          currentCustomer {
            salutation,
            firstName,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            }
          }
        }`, this, 'currentCustomer', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
